<template>
  <v-layout row justify-center>
    <v-dialog v-model="configDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="d-flex align-center mb-0 pb-0">
          <p class="headline">
            Agendamento do Incentivo
            <span :class="`ml-2 small chip-incentive-step  ${$props.config.incentive_step}`">{{
              incentiveApproachSteps[$props.config.incentive_step]
            }}</span>
            <span :class="`small chip-incentive-step  ${$props.config.approach_type}`">{{
              incentiveApproachTypes[$props.config.approach_type]
            }}</span>
          </p>
        </v-card-title>
        <v-card-title class="pt-1"> </v-card-title>
        <v-card-text>
          <v-form ref="configForm" v-model="valid">
            <v-layout row wrap>
              <v-flex class="pl-1" xs12 sm12 md4>
                <v-select
                  @change="
                    () => {
                      configForm.unit = null;
                      configForm.amount = null;
                      configForm.time = null;
                    }
                  "
                  item-text="label"
                  item-value="value"
                  v-model="configForm.type"
                  :items="types"
                  label="Tipo*"
                  required></v-select>
              </v-flex>

              <!-- caso seja selecionado "no dia" -->
              <v-flex v-if="configForm.type === 'today'" class="px-2" xs12 sm12 md4>
                <v-select
                  @change="configForm.amount = null"
                  item-text="label"
                  item-value="value"
                  v-model="configForm.unit"
                  :items="units"
                  label="Unidade*"
                  :rules="requiredRule"
                  required></v-select>
              </v-flex>
              <v-flex v-if="configForm.type === 'today'" class="px-2" xs12 sm12 md4>
                <v-text-field
                  v-model="configForm.amount"
                  type="number"
                  label="Quantidade de tempo*"
                  min="0"
                  :max="configForm.unit === 'hours' ? 24 : 60"
                  :rules="configForm.unit === 'hours' ? hourRules : minuteRules"
                  required></v-text-field>
              </v-flex>

              <!-- caso seja selecionado "dia seguinte"-->
              <v-flex v-if="configForm.type === 'tomorrow'" class="px-2" xs12 sm12 md8>
                <v-text-field
                  v-model="configForm.time"
                  type="time"
                  label="Horário"
                  required
                  :rules="requiredRule"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>

          <v-flex xs12 sm12 md12>
            <v-checkbox
              persistent-hint
              class="mt-0"
              v-model="configForm.alwaysSend"
              label="Sempre enviar"
              hint="Por padrão o incentivo só será enviado para o canal originario do acesso. Caso deseje sempre enviar independente do canal de origem de acesso, deverá marcar a opção."></v-checkbox>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('cancel')">Cancelar</v-btn>
          <v-btn color="accent" flat @click="handleSave" :disabled="!valid">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: ["configDialog", "config"],
  created() {
    if (this.$props.config) {
      this.configForm = {
        type: null,
        unit: null,
        amount: null,
        time: null,
        alwaysSend: false,
      };
      this.parseScheduleStringToForm();
    }
  },
  data: () => ({
    valid: false,
    incentiveApproachTypes: {
      INCENTIVE_SMS: "SMS",
      INCENTIVE_PUSH: "Push",
      INCENTIVE_WHATSAPP: "Whatsapp",
      INCENTIVE_EMAIL: "E-Mail",
    },
    incentiveApproachSteps: {
      LANDING_ACCESSED: "Landing acessada",
      LINK_ACCESSED: "Link Acessado",
      LOGGED_IN: "Login",
      PROPOSAL_SELECTED: "Proposta Selecionada",
      SYNC_RESOLVED: "Propostas Sincronizadas",
    },
    types: [
      { label: "No Dia", value: "today" },
      { label: "Dia seguinte", value: "tomorrow" },
    ],
    units: [
      { label: "Horas", value: "hours" },
      { label: "Minutos", value: "minutes" },
    ],
    configForm: {
      type: null,
      unit: null,
      amount: null,
      time: null,
      alwaysSend: false,
    },
    requiredRule: [(v) => !!v || "O campo é obrigatório"],
    hourRules: [
      (v) => !!v || "O campo é obrigatório",
      (v) => (v >= 0 && v <= 24) || "O número deve ser entre 0 e 24",
    ],
    minuteRules: [
      (v) => !!v || "O campo é obrigatório",
      (v) => (v >= 0 && v <= 60) || "O número deve ser entre 0 e 60",
    ],
  }),
  methods: {
    padLeftTime(value) {
      if (!value) return null;
      const [h = "0", m = "0"] = value.split(":");
      const hh = h.toString().padStart(2, "0");
      const mm = m.toString().padStart(2, "0");
      return `${hh}:${mm}`;
    },
    parseScheduleStringToForm() {
      this.configForm = {
        type: null,
        unit: null,
        amount: null,
        time: null,
        alwaysSend: false,
      };

      if (this.$props.config && this.$props.config.schedule_to) {
        const scheduleParts = this.$props.config.schedule_to.split(" ");

        this.configForm.alwaysSend = this.$props.config.always_send;
        this.configForm.type = this.$props.config.schedule_to.includes("in") ? "today" : "tomorrow";

        if (this.configForm.type === "today") {
          this.configForm.time = null;
          this.configForm.unit = scheduleParts[2];
          this.configForm.amount = scheduleParts[1];
        }

        if (this.configForm.type === "tomorrow") {
          this.configForm.time = this.padLeftTime(scheduleParts[2]);
          this.configForm.amount = null;
          this.configForm.unit = null;
        }
      }
    },
    formatPayload() {
      let schedule_to = null;

      if (this.configForm.type === "today") {
        schedule_to = `in ${this.configForm.amount} ${this.configForm.unit}`;
      } else if (this.configForm.type === "tomorrow") {
        schedule_to = `tomorrow at ${this.configForm.time}`;
      }

      return {
        id: this.$props.config.id,
        incentive_step: this.$props.config.incentive_step,
        approach_type: this.$props.config.approach_type,
        schedule_to,
        always_send: this.configForm.alwaysSend,
      };
    },
    handleSave() {
      this.$emit("save", this.formatPayload());
    },
  },
  watch: {
    configDialog(newVal) {
      if (newVal && this.$props.config) {
        this.parseScheduleStringToForm();
      }
    },
  },
};
</script>
